/* eslint-disable */
import {
  Layout,
  Row,
  Col,
  Card,
  Typography,
  Button,
  Space,
  Select,
  DatePicker,
  message,
  Tooltip,
  Drawer,
  Radio,
} from "antd";
import React, { useEffect, useRef, useState, forwardRef, useImperativeHandle } from "react";
import api from "@/utils/api";
import http from "@/utils/http";
import dayjs from "dayjs";
import { CustomTable } from "@/hocComponents";
import PropertyBreakdown from "./component/PropertyBreakdown";
import commonFn from "@/utils/commonFn";
import rentIcon from "@/assets/images/icons/rent.png";
import utilityIcon from "@/assets/images/icons/utility.png";
import otherIcon from "@/assets/images/icons/other.png";
import "./component/index.scss";

const DelinquencyIndex = forwardRef((props, ref) => {
  const { Content } = Layout;

  const [activeOwnerRecord, setActiveOwnerRecord] = useState(null);
  const [activeOwnerId, setActiveOwnerId] = useState(null); // 添加这一行
  const [showPropertyTable, setShowPropertyTable] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [tableHead, setTableHead] = useState({});
  const [tableLoading, setTableLoading] = useState(false);
  const [currentTopSummary, setCurrentTopSummary] = useState(null);
  const [evictionTopSummary, setEvictionTopSummary] = useState(null);
  const [currentMonth, setCurrentMonth] = useState('');
  const [lastMonth, setLastMonth] = useState('');
  const [currentMonthStr, setCurrentMonthStr] = useState('');
  const [lastMonthStr, setLastMonthStr] = useState('');
  const [pagination, setPagination] = useState({
    page: 1,
    count: 20,
    total: 0,
    totalPages: 0,
  });
  const [pageLoading, setPageLoading] = useState(true);
  const [filters, setFilters] = useState({});
  const isFetching = useRef(false);
  const isInitialized = useRef(false);
const [previousMonthDrawerVisible, setPreviousMonthDrawerVisible] = useState(false);
const [selectedMonth, setSelectedMonth] = useState('');
const [selectedMonthLabel, setSelectedMonthLabel] = useState('');
  // 处理点击 Property Name 打开抽屉
const handlePreviousMonthClick = () => {
  if (lastMonth) {
    setShowPropertyTable(true);
    setSelectedMonth(lastMonth);
    const previousData = evictionTopSummary || {};
    setSelectedMonthLabel(previousData.monthStr || lastMonth);
    setActiveOwnerRecord(null);
    setActiveOwnerId(null);
  } else {
    message.warning("Previous month data not available");
  }
};
const handlePreviousMonthClose = () => {
  setPreviousMonthDrawerVisible(false);
};

  const tableFilterFn = (event, key, type = "Input") => {
    commonFn.tableFilterFn({
      event,
      key,
      type,
      setTableHead,
      getTableListFn: (page, pageSize, tableHeadParams) => {
        const searchValue = tableHeadParams?.propertyName || filters?.propertyName || null;
        fetchTableData(searchValue, page || 1, pageSize || pagination.count);
      },
      pageSize: pagination.count
    });
  };

  const columns = [
    {
      title: "Property Name",
      dataIndex: "propertyName",
      titleType: "Input",
      width: 280,
      onChange: (e) => tableFilterFn(e, "propertyName"),
    },
    {
      title: "Property Type",
      dataIndex: "propertyType",
      width: 120,
    },
    {
      title: "Gross Rent/Invoiced Rent",
      dataIndex: "grossRent",
      width: 180,
      render: (text, record) => {
        const grossRent = record.grossRent || 0;
        const invoicedRent = record.invoicedRent || 0;
        const grossRentFormatted = grossRent > 0 ? commonFn.amountToDollarBracketFn(grossRent) : '';
        const invoicedRentFormatted = invoicedRent > 0 ? commonFn.amountToDollarBracketFn(invoicedRent) : '';

        if (!grossRentFormatted && !invoicedRentFormatted) {
          return '';
        }

        const parts = [grossRentFormatted, invoicedRentFormatted].filter(Boolean);
        return <span>{parts.join(' / ')}</span>;
      },
    },
    {
      title: "Vacancy Loss",
      dataIndex: "vacancyLossRate",
      width: 120,
      // render: (text, record) => {
      //   const value = record.vacancyLossRate;
      //   if (value === null || value === undefined || value === '' || value === 0) return '';
      //   const num = Number(value);
      //   if (!isFinite(num)) return '';
      //   return `${(num * 100).toFixed(2)}%`;
      // },
      isPercentFlag: true, 
    },
    {
      title: "Security Dep.",
      dataIndex: "securityDeposit",
      width: 120,
      render: (text, record) => {
        const value = record.securityDeposit || 0;
        return value > 0 ? commonFn.amountToDollarBracketFn(value) : '';
      },
    },
    {
      title: "Late Charge",
      dataIndex: "lateCharge",
      width: 120,
      render: (text, record) => {
        const value = record.lateCharge || 0;
        return value > 0 ? commonFn.amountToDollarBracketFn(value) : '';
      },
    },
    {
      title: "Utilities",
      dataIndex: "utilities",
      width: 120,
      render: (text, record) => {
        const value = record.utilities || 0;
        return value > 0 ? commonFn.amountToDollarBracketFn(value) : '';
      },
    },
    {
      title: "Other",
      dataIndex: "other",
      width: 120,
      render: (text, record) => {
        const value = record.other || 0;
        return value > 0 ? commonFn.amountToDollarBracketFn(value) : '';
      },
    },
    {
      title: "Advance Rent",
      dataIndex: "advanceRent",
      width: 120,
      render: (text, record) => {
        const value = record.advanceRent || 0;
        return value > 0 ? commonFn.amountToDollarBracketFn(value) : '';
      },
    },
    {
      title: "Back Balance",
      dataIndex: "backBalance",
      width: 120,
      render: (text, record) => {
        const value = record.backBalance || 0;
        return value > 0 ? commonFn.amountToDollarBracketFn(value) : '';
      },
    },
    {
      title: "Past Tenant",
      dataIndex: "pastTenant",
      width: 120,
      render: (text, record) => {
        const value = record.pastTenant || 0;
        return value > 0 ? commonFn.amountToDollarBracketFn(value) : '';
      },
    },
    {
      title: "Total Cash Received",
      dataIndex: "totalCashReceived",
      width: 160,
      render: (text, record) => {
        const value = record.totalCashReceived || 0;
        return value > 0 ? commonFn.amountToDollarBracketFn(value) : '';
      },
    },
  ];

  const fetchMonthInfo = async () => {
    try {
      const response = await http.get(api.getCollectionShowMonth);
      if (response?.code === "1") {
        const { currentMonth, lastMonth } = response?.data || {};
        setCurrentMonth(currentMonth);
        setLastMonth(lastMonth);
        return { currentMonth, lastMonth };
      } else {
        message.error(response?.msg || "Failed to get month info");
        return null;
      }
    } catch (e) {
      message.error("Failed to get month info");
      return null;
    }
  };

  const fetchStatistics = async (month) => {
    try {
      const response = await http.post(api.getCollectionShowSummary, {
        month: month,
      });
      if (response?.code === "1") {
        const data = response?.data || {};
        // 提取月份显示字符串
        if (data.monthStr) {
          if (month === currentMonth) {
            setCurrentMonthStr(data.monthStr);
          } else {
            setLastMonthStr(data.monthStr);
          }
        }
        return data;
      } else {
        return null;
      }
    } catch (e) {
      return null;
    }
  };

  const fetchTableData = async (searchValue = null, page = 1, count = 20) => {
    if (isFetching.current) return;
    isFetching.current = true;
    setTableLoading(true);

    try {
      const params = {
        page: page,
        count: count,
        month: currentMonth,
      };

      if (searchValue) {
        params.propertyName = searchValue;
      }
      const response = await http.post(api.getCollectionShowList, params);

      if (response?.code === "1") {
        const { details, total, totalPages, page: resPage, count: resCount } = response?.data || {};
        const transformedData = transformData(details || []);
        setFilteredData(transformedData);
        setPagination({
          page: resPage || page,
          count: resCount || count,
          total: total || 0,
          totalPages: totalPages || 0,
        });
      } else {
        setFilteredData([]);
        message.error(response?.msg);
      }
    } catch (e) {
      setFilteredData([]);
    } finally {
      setTableLoading(false);
      isFetching.current = false;
    }
  };

  const transformData = (details) => {
    if (!details || !Array.isArray(details)) return [];

    return details.map((item) => ({
      key: `${item.propId}`,
      propId: item.propId,
      propertyName: item.propertyName || '',
      propertyType: item.propertyType || '',
      units: item.units || 0,
      current: item.current || 0,
      days30: item.days30 || 0,
      days60: item.days60 || 0,
      days90Plus: item.days90Plus || 0,
      total: item.total || 0,
      pctOfTotalDelinquency: item.pctOfTotalDelinquency
        ? `${Number(item.pctOfTotalDelinquency).toFixed(2)}%`
        : '',
      grossRent: item.grossRent || 0,
      invoicedRent: item.invoicedRent || 0,
      vacancyLossRate: item.vacancyLossRate || 0,
      securityDeposit: item.securityDeposit || 0,
      lateCharge: item.lateCharge || 0,
      utilities: item.utilities || 0,
      other: item.other || 0,
      advanceRent: item.advanceRent || 0,
      backBalance: item.backBalance || 0,
      pastTenant: item.pastTenant || 0,
      totalCashReceived: item.totalCashReceived || 0,
      rawData: item,
    }));
  };

  const initData = async () => {
    setPageLoading(true);
    try {
      const monthInfo = await fetchMonthInfo();
      if (!monthInfo) {
        const defaultMonth = dayjs().format("YYYY-MM");
        setCurrentMonth(defaultMonth);
        const data = await fetchStatistics(defaultMonth);
        if (data) {
          setCurrentTopSummary(data);
        }
        await fetchTableData();
        return;
      }

      const { currentMonth: curMonth, lastMonth: lastMon } = monthInfo;

      const [currentData, lastData] = await Promise.all([
        fetchStatistics(curMonth),
        fetchStatistics(lastMon),
      ]);

      if (currentData) {
        setCurrentTopSummary(currentData);
      }
      if (lastData) {
        setEvictionTopSummary(lastData);
      }

      await fetchTableData();
    } catch (e) {
      message.error("Failed to initialize data");
    } finally {
      setPageLoading(false);
    }
  };

const handleClose = () => {
  setShowPropertyTable(false);
  setSelectedMonth('');
  setSelectedMonthLabel('');
};
  // useImperativeHandle(ref, () => ({
  //   refresh() {
  //     if (isInitialized.current && !isFetching.current) {
  //       const searchValue = filters?.propertyName || null;
  //       fetchTableData(searchValue, pagination.page, pagination.count);
  //     }
  //   }
  // }));
useImperativeHandle(ref, () => ({
  refresh() {
    if (!isFetching.current) {
      const searchValue = filters?.propertyName || null;
      // 刷新表格数据
      fetchTableData(searchValue, pagination.page, pagination.count);
      // 同时刷新统计卡片数据
      if (currentMonth) {
        // 重新获取统计数据
        const refreshStatistics = async () => {
          const monthInfo = await fetchMonthInfo();
          if (monthInfo) {
            const { currentMonth: curMonth, lastMonth: lastMon } = monthInfo;
            const [currentData, lastData] = await Promise.all([
              fetchStatistics(curMonth),
              fetchStatistics(lastMon),
            ]);
            if (currentData) setCurrentTopSummary(currentData);
            if (lastData) setEvictionTopSummary(lastData);
          }
        };
        refreshStatistics();
      }
    }
  }
}));
  useEffect(() => {
    const init = async () => {
      await initData();
      isInitialized.current = true;
    };
    init();
  }, []);

const renderStatCards = () => {
  const currentData = currentTopSummary || {};
  const previousData = evictionTopSummary || {};

  const renderCardContent = (data, title, monthLabel) => {
    const isPrevious = title === "Previous Month";
    
    // 三个主要指标
    const mainItems = [
      { 
        label: "Total Tenant Cash Received", 
        key: "totalTenantCashReceived",
        extra: null
      },
      { 
        label: "Gross Rent/Invoiced Rent", 
        key: "grossRent",
        extra: (data) => {
          const vacancyRate = data.vacancyLossRate || 0;
          const vacancyPercent = vacancyRate > 0 ? `${(vacancyRate * 100).toFixed(2)}%` : '';
          return vacancyPercent ? (
            <div className="delinquency-stat-main-extra">
              <span className="delinquency-stat-main-extra-label">Vacancy Loss</span>
              <span className="delinquency-stat-main-extra-value">{vacancyPercent}</span>
            </div>
          ) : null;
        }
      },
      { 
        label: "Rent Collected", 
        key: "rentCollected",
        extra: (data) => {
          const collectionRate = data.collectionRate || 0;
          const collectionPercent = collectionRate > 0 ? `${(collectionRate * 100).toFixed(2)}%` : '';
          return collectionPercent ? (
            <div className="delinquency-stat-main-extra">
              <span className="delinquency-stat-main-extra-label">Collection</span>
              <span className="delinquency-stat-main-extra-value">{collectionPercent}</span>
            </div>
          ) : null;
        }
      },
    ];

    // 底部两个分类指标
    const categoryItems = [
      { label: "RPS", key: "rpsAmount" },
      { label: "Manual", key: "manualAmount" },
    ];

    const formatGrossRentDisplay = (data) => {
      const grossRent = data.grossRent || 0;
      const invoicedRent = data.invoicedRent || 0;
      const grossFormatted = commonFn.amountToDollarBracketFn(grossRent);
      const invoicedFormatted = commonFn.amountToDollarBracketFn(invoicedRent);
      return `${grossFormatted} / ${invoicedFormatted}`;
    };

    return (
      <div 
        className={`delinquency-stat-card ${isPrevious ? 'delinquency-stat-card-clickable' : ''}`}
        onClick={isPrevious ? handlePreviousMonthClick : undefined}
      >
        <div className="delinquency-stat-card-header">
          <span className="delinquency-stat-card-title">
            {title} ({monthLabel})
          </span>
        </div>

        <Row gutter={0} className="delinquency-stat-card-inner">
          <Col span={19} className="delinquency-stat-left-col">
            <Row gutter={0} className="delinquency-stat-main-row">
              {mainItems.map((item) => (
                <Col span={8} key={item.key}>
                  <div className="delinquency-stat-main-item">
                    <div className="delinquency-stat-main-label">{item.label}</div>
                    <div className="delinquency-stat-main-value">
                      {item.key === 'grossRent'
                        ? formatGrossRentDisplay(data)
                        : commonFn.amountToDollarBracketFn(data[item.key] || 0)
                      }
                    </div>
                    {item.extra && item.extra(data)}
                  </div>
                </Col>
              ))}
            </Row>
          </Col>

          <Col span={1} className="delinquency-stat-divider-col">
            <div className="delinquency-stat-divider" />
          </Col>

          <Col span={4} className="delinquency-stat-right-col">
            <div className="delinquency-stat-category-list">
              {categoryItems.map((item, index) => (
                <div className="delinquency-stat-category-item" key={item.key}>
                  <span 
                    className="delinquency-stat-category-dot" 
                    style={{ background: index === 0 ? '#2563EB' : '#E17100' }}
                  />
                  <span className="delinquency-stat-category-label">{item.label}</span>
                  <span className="delinquency-stat-category-value">
                    {commonFn.amountToDollarBracketFn(data[item.key] || 0)}
                  </span>
                </div>
              ))}
            </div>
          </Col>
        </Row>
      </div>
    );
  };

  const currentMonthLabel = currentData.monthStr;
  const previousMonthLabel = previousData.monthStr;

  return (
    <Row gutter={16} className="delinquency-stat-cards-row">
      <Col span={12}>
        <Card className="delinquency-stat-card-wrapper" bordered={false}>
          {renderCardContent(currentData, "Current Month", currentMonthLabel)}
        </Card>
      </Col>
      <Col span={12}>
        <Card 
          className={`delinquency-stat-card-wrapper ${lastMonth ? 'delinquency-stat-card-wrapper-clickable' : ''}`}
          bordered={false}
        >
          {renderCardContent(previousData, "Previous Month", previousMonthLabel)}
        </Card>
      </Col>
    </Row>
  );
};

  return (
    <div className="delinquency-dashboard-layout">
      <Content className="delinquency-dashboard-content">
        {renderStatCards()}

        <CustomTable
          tableLoading={tableLoading || pageLoading}
          columns={columns}
          tableList={filteredData}
          rowKey="key"
          pagination={{
            current: pagination.page,
            pageSize: pagination.count,
            total: pagination.total,
          }}
          setTableHead={setTableHead}
          getTableListFn={(page, pageSize, tableHeadParams) => {
            const searchValue = tableHeadParams?.propertyName || filters?.propertyName || null;
            fetchTableData(searchValue, page, pageSize);
          }}
          tableScrollX={undefined}
          tableScrollY="496px"
        />

  <Drawer
  placement="bottom"
  open={showPropertyTable}
  onClose={handleClose}
  height="100%"
  closable={false}
  title={null}
  getContainer={false}
  mask={false}
  style={{
    padding: 0,
    overflow: "visible",
    position: "absolute",
    overflow: "hidden",
  }}
>
  <div
    style={{
      height: "100%",
      display: "flex",
      flexDirection: "column",
      overflow: "hidden",
    }}
  >
    <PropertyBreakdown
      supervisorId={activeOwnerId}
      supervisorName={activeOwnerRecord?.propertyName}
      ownerRecord={activeOwnerRecord}
      visible={showPropertyTable}
      onClose={handleClose}
      month={selectedMonth || undefined}
    />
  </div>
</Drawer>
      </Content>
    </div>
  );
});

export default DelinquencyIndex;